(function ($) {
    'use strict';

    $.validateForm = ($form) => {
        let formValid = true;

        $form.find('[required]').each(function(){
            if($(this).is(':invalid') || !$(this).val()){
                formValid = false;
                $(this).addClass('error');
                return false;
            }
        });

        return formValid;
    };

}(jQuery));